import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg className={styles["myhouse_main_certification--close"] || "myhouse_main_certification--close"} xmlns="http://www.w3.org/2000/svg" width="14" height="14" {...props}><g fill="#C9CCD1" fillRule="evenodd"><path d="M1.96 1L13 12.04l-.96.96L1 1.96z" /><path d="M12.04 1L1 12.04l.96.96L13 1.96z" /></g></svg>);